import { ServiceCandidate, trainingServe } from "@/utils/request";

function getReminders(code) {
  return trainingServe({
    url: "/candidate/course-reminder/",
    method: "get",
    params: {
      code,
    },
  });
}

function createReminder(data) {
  return trainingServe({
    url: "/candidate/course-reminder/",
    method: "post",
    data,
  });
}

function updateReminder(data) {
  return trainingServe({
    url: "/candidate/course-reminder/",
    method: "put",
    data,
  });
}

function deleteReminder(reminderID) {
  return trainingServe({
    url: "/candidate/course-reminder/?reminderID=" + reminderID,
    method: "delete",
  });
}

function getInfo() {
  return trainingServe({
    url: "candidate/candidate-info/",
    method: "get",
  });
}

const staticImage = (name) => {
  return ServiceCandidate({
    url: "user/static-image/?name=" + name,
    method: "GET",
  });
};

const headerName = (name) => {
  return ServiceCandidate({
    url: "can/profile-info/",
    method: "GET",
  });
};

export {
  getReminders,
  createReminder,
  updateReminder,
  deleteReminder,
  getInfo,
  staticImage,
  headerName,
};
